export const getDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;

  // Detect Device Type
  let deviceType = "Unknown";
  if (/android/i.test(userAgent)) deviceType = "Android";
  else if (/iPhone|iPad|iPod/i.test(userAgent)) deviceType = "iOS";
  else if (/Win/i.test(platform)) deviceType = "Windows";
  else if (/Mac/i.test(platform)) deviceType = "Mac";
  else if (/Linux/i.test(platform)) deviceType = "Linux";

  // Detect Browser
  let browser = "Unknown";
  if (userAgent.includes("Chrome")) browser = "Chrome";
  if (userAgent.includes("Firefox")) browser = "Firefox";
  if (userAgent.includes("Safari") && !userAgent.includes("Chrome"))
    browser = "Safari";
  if (userAgent.includes("Edg")) browser = "Edge";
  if (userAgent.includes("OPR") || userAgent.includes("Opera"))
    browser = "Opera";

  // OS Name
  let os = "Unknown";
  if (userAgent.includes("Windows NT")) os = "Windows";
  else if (userAgent.includes("Android")) os = "Android";
  else if (/iPhone|iPad|iPod/i.test(userAgent)) os = "iOS";
  else if (userAgent.includes("Mac OS X")) os = "MacOS";
  else if (userAgent.includes("Linux")) os = "Linux";

  return {
    deviceType,
    browser,
    os,
    userAgent,
  };
};
